module.exports = __webpack_public_path__ + "img/Size=16, Style=solid.3ec556ce.svg";